module.exports = {
    INITIAL_PAGE_INDEX: 1,
    DEFAULT_ROWS_PER_PAGE: 25,
    PAGING_DIRECTION: {
        Next: 'next',
        Previous: 'prev'
    }
};
